import { Select } from '@material-ui/core';
import React, { Component } from 'react';

class CustomizedSelect extends Component {

    render() {
        return (
            <Select {...this.props}
                MenuProps={{
                    anchorOrigin: { vertical: "bottom", horizontal: "center" },
                    transformOrigin: { vertical: "top", horizontal: "center" },
                    getContentAnchorEl: null,
                }} />
        )
    }
}

export default (CustomizedSelect);
